<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>Edit Enquiry </h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleConfirm">Update</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          v-if="![20,30,40].includes(formData.enquiry_type)"
          class="box">
          <div class="form form1">

            <div
              v-if="[10].includes(formData.enquiry_type)||[20,30,40].includes(formData.enquiry_type)&&isFina"
              class="item">
              <span class="item-title">Product Type</span>
              <el-form-item
                ref="product_type"
                :rules="rules.select"
                prop="product_type">
                <v-select
                  v-model="formData.product_type"
                  :list="globalOptions.enquiry_product_type"/>
              </el-form-item>
              <el-form-item
                v-if="[10,20,40].includes(formData.product_type)"
                ref="product_type"
                class="mg-t-10"
                :rules="rules.select"
                prop="product_type">
                <v-select
                  v-model="formData.class_id"
                  :list="classList(formData.product_type)"/>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Title</span>
              <el-form-item
                ref="title"
                :rules="rules.select"
                prop="title">
                <v-select
                  v-model="formData.title"
                  :list="globalOptions.enquiry_title"/>
              </el-form-item>
            </div>

            <div class="item">
              <span class="item-title">{{ [20,30,40].includes(formData.enquiry_type)&&isFina?'Policyholder Name':'Name' }}</span>
              <el-form-item
                ref="name"
                :rules="rules.input"
                prop="name">
                <v-input
                  v-model="formData.name"
                  uppercase />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Mobile Number</span>
              <el-form-item
                ref="phone"
                :rules="rules.mobile_no"
                prop="phone">
                <v-input
                  v-model="formData.phone"
                  maxlength="8"
                  keyNumber
                  uppercase></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Email</span>
              <el-form-item
                ref="email"
                :rules="rules.contact_email"
                prop="email">
                <v-input
                  v-model="formData.email"
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Additional Message</span>
              <el-form-item
                ref="additional_msg"
                :rules="rules.input"
                prop="additional_msg">
                <v-input
                  v-model="formData.additional_msg"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
            <div
              v-if="![20,30,40].includes(formData.enquiry_type)&&!isFina||isFina"
              class="form-item mg-t-20"
            >
              <el-form-item
                ref="is_policy_holder"
                prop="is_policy_holder">
                <v-checkbox
                  v-model="formData.is_policy_holder"
                  :isBoolean="false"
                >
                  I am the policyholder
                </v-checkbox>
              </el-form-item>
            </div>
          </div>

        </div>
        <div
          v-if="[20,40].includes(formData.enquiry_type)"
          class="box">
          <div class="form form1">
            <div
              class="item">
              <el-form-item
                ref="endorse_action"
                :rules="rules.select"
                prop="endorse_action">
                <v-radio-group
                  v-model="formData.endorse_action"
                  block
                  :list="isRenew?renewActionOption:actionOption"/>
              </el-form-item>
            </div>
            <template>
              <div
                class="item">
                <span class="item-title">Contact Email</span>
                <el-form-item
                  ref="email"
                  :rules="rules.contact_email"
                  prop="email">
                  <v-input
                    v-model="formData.email"
                    :disabled="isFina?true:false"
                  />
                </el-form-item>
              </div>
              <div class="item">
                <span class="item-title">Contact Number</span>
                <el-form-item
                  ref="phone"
                  :rules="rules.mobile_no"
                  prop="phone">
                  <v-input
                    v-model="formData.phone"
                    :disabled="isFina?true:false"
                    uppercase />
                </el-form-item>
              </div>
            </template>
            <div class="item">
              <span class="item-title">Additional Message</span>
              <el-form-item
                ref="additional_msg"
                :rules="rules.input"
                prop="additional_msg">
                <v-input
                  v-model="formData.additional_msg"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
          </div>

        </div>
        <div
          v-if="isClaim"
          class="box">
          <div class="form form1">
            <div class="form-item">
              <span>Accident Date</span>
              <el-form-item prop="accident_date">
                <v-date-picker v-model="formData.accident_date" />
              </el-form-item>
            </div>
            <template v-if="isMotor">
              <div class="form-item">
                <span class="pd-b-0 ">Accident Driver Name</span>
                <span class="fs-12 color-gray">Must be the same as HKID</span>
                <div class="flex mg-t-3">
                  <div class="mg-r-8">
                    <el-form-item
                      ref="isrd_lst_nm"
                      prop="isrd_lst_nm">
                      <v-input
                        v-model="formData.isrd_lst_nm"
                        placeholder="Last Name"
                      />
                    </el-form-item>
                  </div>
                  <el-form-item
                    ref="isrd_fst_nm"
                    prop="isrd_fst_nm">
                    <v-input
                      v-model="formData.isrd_fst_nm"
                      placeholder="First Name"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <span>Accident Driver HKID Number</span>
                <el-form-item
                  ref="id_no"
                  prop="id_no">
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    placeholder="A123456(3), please input A1234563"
                  />
                </el-form-item>
              </div>
            </template>
            <template v-if="isTravelOrPA">
              <div class="form-item">
                <span class="pd-b-0 ">Accident Insured</span>
                <span class="fs-12 color-gray ">If there is another person responsible, please file another claim.</span>
                <el-form-item
                  ref="id_no"
                  :rules="rules.select"
                  prop="id_no">
                  <v-select
                    v-model="formData.id_no"
                    :list="list"
                    value-key="id_no"
                    :labelKey="'lst_nm'"
                    show-name
                    :labelSecondKey="'fst_nm'"
                    class="mg-t-3" />
                </el-form-item>
              </div>
            </template>
            <template v-if="!isMotor&&!isTravelOrPA&&!isSme">
              <div class="form-item">
                <span>Accident Insured</span>
                <el-form-item prop="isrd_nm">
                  <v-input
                    v-model="formData.isrd_nm"
                    disabled />
                </el-form-item>
              </div>
            </template>
            <div class="form-item">
              <span>Contact Person</span>
              <el-form-item prop="name">
                <v-input
                  v-model="formData.name" />
              </el-form-item>
            </div>

            <div class="form-item">
              <span>Contact Number</span>
              <el-form-item
                ref="phone"
                prop="phone"
                :rules="rules.mobile_no">
                <v-input
                  v-model="formData.phone" />
              </el-form-item>
            </div>
            <div class="form-item mg-b-10">
              <span>Brief Description Of The Accident</span>
              <el-form-item prop="additional_msg">
                <v-input
                  v-model="formData.additional_msg"
                  type="textarea"
                  :rows="4" />
              </el-form-item>
            </div>
          </div>

        </div>
      </el-form>
      <div class="footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="handleConfirm">Update</v-button>
      </div>
    </div>
    <aside>
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remark"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.agent }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            :maxlength="1000"
            append="Add"
            @handlerAppend="handlerRemark"/>
        </div>
      </div>
    </aside>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {saveEnquiry,addEnquiryRemark} from '@/api/enquiry'
import axios from 'axios'
import dayjs from 'dayjs'
export default {
  name: 'enquiryForm',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    from:{
      type:Object,
      default:()=>({})
    },
    remark:{
      type:Array,
      default:()=>([])
    },
    list:{
      type:Array,
      default:()=>([])
    },
  },
  data () {
    return {
      formData:{
        mobile_no:'',
        email:'',
        rgtn_no:'',
        name: '',
        phone: '',
        additional_msg: '',
        is_policy_holder:'',
        // contact_dt:'',
        pcy_no:'',
        // contact_time_id:'',
        product_type:'',
        enquiry_type:10,
        class_id:11,
        company_id:'',
        title:'',
        endorse_action:'',
        merchant_platform:'',

        accident_date: '',
        customer_id: '',
        isrd_nm:'',
        id_type:1,
        id_no:'',
        isrd_fst_nm:'',
        isrd_lst_nm:'',
      },
      message:'',
      pickerOptions: {
        disabledDate: (time) => {
          const day = time.getDay()
          const formattedDate = this.formatDate(time)
          const today = this.formatDate(new Date())
          const currentYear = dayjs().year()
          const year = dayjs(time).year()
          const nextYear = currentYear + 1
          return day === 0 || day === 6 || this.holidays.includes(formattedDate)||formattedDate<today||year > nextYear
        },
        shouldShowToday: true
      },
    }
  },
  computed:{
    isFina(){
      let {merchant_platform} = this.from
      return merchant_platform==2
    },
    holidays(){
      let {holiday_data} = this.globalOptions||{}
      let holidays = holiday_data.map(holiday =>holiday.date)
      return holidays
    },
    enquiry_id(){
      let {id} = this.$route.query
      return id
    },
    classList(product_type){
      return product_type =>{
        let arr =[]
        let {enquiry_cs_product_type} = this.globalOptions||{}
        enquiry_cs_product_type.some(item=>{
          let itemId = item.id.toString()
          const numberString = item.id.toString()
          const firstTwoDigits = numberString.slice(0, 2)
          const last = numberString.slice(2, 4)
          if(firstTwoDigits == product_type){
            let class_id = Number(last)
            let obj = {
              id:class_id,
              name:item.name
            }
            arr.push(obj)
          }
        })
        return arr
      }
    },
    actionOption(){
      return [
        {
          name: 'Endorsement',
          id: 1
        },
        {
          name: 'Cancel Policy',
          id: 2
        }
      ]
    },
    renewActionOption(){
      return [
        {
          name: 'Endorsement',
          id: 1
        },
        {
          name: 'Other',
          id: 9
        }
      ]
    },
    productId(){
      let {order_detail} = this.from
      let {product_id} = order_detail||{}
      return  product_id||''
    },
    isMotor(){
      return this.productId == 11
    },
    isClaim(){
      let {enquiry_type} = this.from
      return enquiry_type == 30
    },
    isRenew(){
      let {enquiry_type} = this.from
      return enquiry_type == 40
    },
    isTravelOrPA(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
    isSme(){
      return this.productId == 80
    },
  },
  watch:{
    from:{
      immediate:true,
      handler(val){
        Object.keys(this.formData).some(key=>{
          // if(val&&val[key]){
          this.formData[key] = val[key]
          let {isrd_nm}  =val||{}
          if(this.isMotor&&this.isClaim&&isrd_nm){
            let name = isrd_nm.split(' ')||[]
            this.formData.isrd_lst_nm = name[0]||''
            this.formData.isrd_fst_nm = name[1]||''
          }
          // }
        })
      }
    }
  },
  mounted(){
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },
    handlerSkip(){
      let params ={
        content:'',
        is_send:0
      }
      this.handleSubscribeSend(params)
    },
    handlerSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.handleSubscribeSend(params)
    },
    handleCancel(){
      this.$emit('cancel')
    },
    handlerRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    handleConfirm(){

      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().saveEnquiry()
        }

      })
    },
    network() {
      return {
        saveEnquiry: async (params) => {
          if(this.isMotor&&this.from.enquiry_type==30){
            let {isrd_lst_nm,isrd_fst_nm} = this.formData||{}
            this.formData.isrd_nm = `${isrd_lst_nm} ${isrd_fst_nm}`
          }
          const { data } = await saveEnquiry({
            enquiry_id: this.enquiry_id,
            ...this.formData
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.$emit('success')
        },
        addAccountRemark: async () => {
          const {data} = await addEnquiryRemark({
            enquiry_id: this.enquiry_id,
            content: this.message
          })
          this.message = ''
          this.$emit('updateRemark')
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  /deep/.el-radio-group{
    display: flex;
    flex-direction: column;
  }
  /deep/.el-radio{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
    & + .el-radio{
      margin-top: 4px;
    }
  }
}
</style>
